"use client";

import { WIDGET_H3 } from "@/components/tool-kit/styles";

/** The numbered working under a result: each step is a finished sentence or equation. */
export function Working({
  heading,
  steps,
}: {
  heading: string;
  steps: readonly string[];
}) {
  if (steps.length === 0) {
    return null;
  }
  return (
    <div className="space-y-2">
      <h3 className={WIDGET_H3}>{heading}</h3>
      <ol className="list-decimal space-y-2 rounded-lg border border-border bg-card py-3 pr-4 pl-8 text-foreground text-sm leading-relaxed">
        {steps.map((step, index) => (
          // Steps are positional, generated text with no identity of their own.
          // biome-ignore lint/suspicious/noArrayIndexKey: positional steps
          <li className="font-mono" key={index}>
            {step}
          </li>
        ))}
      </ol>
    </div>
  );
}
